<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
<div class="flex flex-column align-items-center" style="width: 100%; margin: 0px;">
  <div class="flex align-items-center justify-content-between w-full grid card">

    <div *ngIf="isAuthenticated" class="bg-container-auth">
      <div class="container-auth">

        <div class="flex align-items-center justify-content-between lg:justify-content-start col-12 md:col-12 lg:col-6 pb-0">
          <button *ngIf="isAuthenticated && fullScreen && isMarketplace && !isMobile"
            (click)="displaySidebar = true" class="only-desktop burger-btn">
            <i class="pi pi-bars" style="font-size: 2em"></i>
          </button>

          <div class="pl-3 mr-6" style="width: 150px; height: 68px;">
            <a [routerLink]="'/'"><img src="../../../../assets/img/fruzty-logo.png" loading="lazy"
              style="width: 150px; height: auto;" alt="fruzty-logo"/></a>
          </div>

          <div class="inline lg:hidden"><app-switch-lang [showOnlyIcon]="true" [showClear]="false"></app-switch-lang></div>
          <button (click)="displaySidebar = true"
            class="btn-menu only-mobile inline lg:hidden"icon="pi pi-bars">
            <i class="pi pi-bars"></i>
          </button>

          <p-button  #goMarketplace *ngIf="profile?.type == 3" label="Admin Panel" (onClick)="goToAdminPanel()"
            class="hidden lg:inline" styleClass="p-button-text p-button-sm" icon="pi pi-users" pRipple [style]="{'max-height': '37px'}">
          </p-button>

          <div *ngIf="profile?.type === 1" class="flex flex-row">
            <p-button (onClick)="goToMarketplace()"
              class="hidden lg:inline"
              styleClass="p-button-text p-button-secondary p-button-sm"
              [style]="{'max-height': '37px'}">
              <span class="material-symbols-outlined" style="font-size: 25px;" [class.visible]="materialIconsReady">nutrition</span>
              <span style="margin-left: 6px">Marketplace</span>
            </p-button>

            <p-button (onClick)="goToProgram()"
              class="hidden lg:inline"
              [style]="{'max-height': '37px'}"
              styleClass="p-button-text p-button-sm p-button-primary">
              <span class="material-symbols-outlined" style="font-size: 23px;" [class.visible]="materialIconsReady">calendar_month</span>
              <span style="margin-left: 6px">{{ 'HomeHeader.UserDashboard.ProgramButton' | translate }}</span>
            </p-button>
          </div>

          <div *ngIf="profile?.type === 2" class="flex flex-row">
            <div *ngIf="selectedFlow.includes('marketplace')">
              <p-button (onClick)="goToMarketplace()"
                class="hidden lg:inline"
                styleClass="p-button-text p-button-secondary p-button-sm"
                [style]="{'max-height': '37px'}">
                <span class="material-symbols-outlined" style="font-size: 25px;" [class.visible]="materialIconsReady">nutrition</span>
                <span style="margin-left: 6px">Marketplace</span>
              </p-button>
            </div>

            <div *ngIf="selectedFlow.includes('program')">
              <p-button (onClick)="goToProgram()"
                class="hidden lg:inline"
                [style]="{'max-height': '37px'}"
                [styleClass]="'p-button-text p-button-sm ' + (selectedFlow.includes('marketplace') ? 'p-button-primary' : 'p-button-secondary')">
                <span class="material-symbols-outlined" style="font-size: 23px;" [class.visible]="materialIconsReady">calendar_month</span>
                <span style="margin-left: 6px">{{ 'HomeHeader.UserDashboard.ProgramButton' | translate }}</span>
              </p-button>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-12 lg:col-6 hidden lg:block pb-0 justify-content-end">
          <app-user-menu></app-user-menu>
        </div>

      </div>
    </div>

    <div *ngIf="!isAuthenticated" class="bg-container">
      <div class="container">
        <figure (click)="goToHome()" style="margin:0;padding:0;cursor:pointer;display:flex; height: 68px;">
          <img src="../../../../assets/img/fruzty-logo.png" style="width: 170px; height: auto;" alt="fruzty-logo" loading="lazy"/>
        </figure>

        <div class="section-right">
          <section class="section-links">

            <div class="link-main only-desktop" (click)="goToHome()" [ngClass]="{'active': isActive('/')}">
              <i class="pi pi-home" style="font-size: 1.4em; padding-right:0.25em"></i>
              <span style="margin-left: 6px">{{'HomeHeader.Home' | translate}}</span>
            </div>
            <div id="goMarketplace" class="link-main only-desktop" (click)="goToMarketplaceAd()" [ngClass]="{'active': isActive('/offers')}">
              <span class="material-symbols-outlined icon-svg" style="font-size: 25px;" [class.visible]="materialIconsReady">nutrition</span>
              <span style="margin-left: 6px">{{'HomeHeader.Marketplace' | translate}}</span>
            </div>
          </section>

          <section class="section-links-right">
            <app-switch-lang></app-switch-lang>
<!--             <button pButton class="btn-login only-desktop" style="padding:0.5em 1em" label="{{'HomeHeader.UserDashboard.LoginButtonLabel' | translate}}" (click)="goToLogin()"></button>
 -->
            <button class="btn-menu only-mobile" (click)="displaySidebar = true" icon="pi pi-bars">
              <i class="pi pi-bars"></i>
            </button>

          </section>
        </div>

      </div>
    </div>
  </div>

  <div class="mt-8">
    <app-disclaimer></app-disclaimer>
  </div>

  <div class="container-bg">
    <div class="container-sidebar only-desktop" *ngIf="!fullScreen && !isMobile">
      <app-sidebar
        [showContainerUser]="true"
        [userCompleteName]="userCompleteName"
        [profileName]="profileName"
        [profileCompanyName]="profileCompanyName"
        [items]="items"
        (goToUserContactInfo)="goToUserContactInfo()"
      />
    </div>
    <div [class]="contentCssClass">
      <ng-content></ng-content>
    </div>
  </div>
</div>
<div [ngClass]="{'overlay-active':displaySidebar}" (click)="displaySidebar = false">
</div>


<div class="container-sidebar-mobile card flex" *ngIf="isAuthenticated">
  <p-sidebar [(visible)]="displaySidebar" [transitionOptions]="'1000ms'"
    [style]="{'width':'300px'}">

    <div class="container-welcome">
      <app-sidebar
        [showContainerUser]="!isMobile"
        [userCompleteName]="userCompleteName"
        [profileName]="profileName"
        [profileCompanyName]="profileCompanyName"
        [items]="items"
        (goToUserContactInfo)="goToUserContactInfo()"
      />
    </div>

    <ng-template pTemplate="footer">
      <div *ngIf="isMobile" class="flex flex-column menu-items hidden lg:inline">
        <div (click)="onClickMenuOption('account')" onKeyPress=""
          class="flex flex-row menu-item" [ngClass]="{'menu-item-active': urlSegment1 === 'user-panel'}">
          <span class="material-symbols-outlined menu-item-icon">
            account_circle
          </span>
          <span>{{'HomeHeader.UserMenu.AccountItem' | translate}}</span>
        </div>

        <div (click)="onClickMenuOption('help')" onKeyPress=""
          class="flex flex-row menu-item" [ngClass]="{'menu-item-active': urlSegment1 === 'user-support'}">
          <span class="material-symbols-outlined menu-item-icon">
            help
          </span>
          <span>{{'UserMenuComponent.HelpMenuItems.CustomerHelpLabel' | translate}}</span>
        </div>

        <div (click)="onClickMenuOption('logout')" onKeyPress=""
          class="flex flex-row menu-item">
          <span class="material-symbols-outlined menu-item-icon">
            login
          </span>
          <span>{{'HomeHeader.UserMenu.LogoutToolTip' | translate}}</span>
        </div>
      </div>
    </ng-template>

  </p-sidebar>
</div>

<div class="container-sidebar-mobile"  *ngIf="!isAuthenticated">
  <p-sidebar [(visible)]="displaySidebar" [modal]="false" [transitionOptions]="'1000ms'" [style]="{'width':'300px'}">
    <div class="container-sidebar">
      <p-panelMenu [model]="itemsUnauth">
        <ng-template let-item pTemplate="item">
        </ng-template>
      </p-panelMenu>

      <div class="sidebar-login-section only-mobile">
        <button pButton class="btn-login full-width" icon="pi pi-sign-in" (click)="goToLogin()"
          label="{{'HomeHeader.UserDashboard.LoginButtonLabel' | translate}}"
        ></button>
      </div>
    </div>
  </p-sidebar>
</div>



<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleCreateExportOfferOptionDialog" [style]="{width: '80%'}">
  <app-export-offer-create-option></app-export-offer-create-option>
</p-dialog>

<p-dialog
  header="{{'UserPages.UserClosedSale.ModalTitle' | translate}}"
  [(visible)]="visibleInvite"
  [style]="{width: '50vw'}"
  [resizable]="false" [modal]="true" [draggable]="false"
>
  <app-closed-sale-join-request
    (handleCloseVisibility)="visibleInvite = false"
  />
</p-dialog>

<p-menu #importerMarketplace [model]="importerMarketplaceMenuItems" [popup]="true"></p-menu>

<p-blockUI [blocked]="loading">
  <span class="text-white text-xl font-bold">...{{'CommonLabels.Loading' | translate}}</span>
</p-blockUI>
